export default "__VITE_ASSET__BwdOot0Z__"